

export const marketTypes = [
    { "id": "Albania", "MarketName": "Albania" },
    { "id": "Czech Republic", "MarketName": "Czech Republic" },
    { "id": "DR Congo", "MarketName": "DR Congo" },
    { "id": "Egypt", "MarketName": "Egypt" },
    { "id": "Ethiopia", "MarketName": "Ethiopia" },
    { "id": "Germany", "MarketName": "Germany" },
    { "id": "Ghana", "MarketName": "Ghana" },
    { "id": "Greece", "MarketName": "Greece" },
    { "id": "IoT Nxt", "MarketName": "IoT Nxt" },
    { "id": "Ireland", "MarketName": "Ireland" },
    { "id": "Italy", "MarketName": "Italy" },
    { "id": "Kenya", "MarketName": "Kenya" },
    { "id": "Lesotho", "MarketName": "Lesotho" },
    { "id": "Luxembourg", "MarketName": "Luxembourg" },
    { "id": "Mezzanine", "MarketName": "Mezzanine" },
    { "id": "Mozambique", "MarketName": "Mozambique" },
    { "id": "Netherlands", "MarketName": "Netherlands" },
    { "id": "Nexio", "MarketName": "Nexio" },
    { "id": "Other", "MarketName": "Other" },
    { "id": "Portugal", "MarketName": "Portugal" },
    { "id": "Romania", "MarketName": "Romania" },
    { "id": "South Africa", "MarketName": "South Africa" },
    { "id": "Spain", "MarketName": "Spain" },
    { "id": "Tanzania", "MarketName": "Tanzania" },
    { "id": "Turkey", "MarketName": "Turkey" },
    { "id": "United Kingdom", "MarketName": "United Kingdom" },
    { "id": "VOIS", "MarketName": "VOIS" },
    { "id": "Vodacom Group", "MarketName": "Vodacom Group" },
    { "id": "Vodafone Group", "MarketName": "Vodafone Group" },
    { "id": "X-Link", "MarketName": "X-Link" }
]

export const businessUnitTypes = [
    { "id": "Consumer", "DivisionName": "Consumer" },
    { "id": "M-Pesa", "DivisionName": "M-Pesa" },
    { "id": "Customer Operations and Support", "DivisionName": "Customer Operations and Support" },
    { "id": "Enterprise", "DivisionName": "Enterprise" },
    { "id": "Financial and Digital Services", "DivisionName": "Financial and Digital Services" },
    { "id": "Other (e.g. Risk, Legal, HR, Subsidiaries)", "DivisionName": "Other (e.g. Risk, Legal, HR, Subsidiaries)" },
    { "id": "Technology", "DivisionName": "Technology" },
    { "id": "Vodacom Group", "DivisionName": "Vodacom Group" },
    { "id": "Vodafone Group", "DivisionName": "Vodafone Group" }
]

export const statusArray = [
    { label: "Active", value: "ACTIVE" },
    { label: "Not New", value: "NOT_NEW" },
    { label: "Evaluating", value: "EVALUATING" },
    { label: "Investigating", value: "INVESTIGATING" },
    { label: "Incubating", value: "INCUBATING" },
    { label: "Implemented", value: "IMPLEMENTED" },
    { label: "Implementing", value: "IMPLEMENTING" },
    { label: "Implemented with PIR", value: "IMPLEMENTED_PIR" },
    { label: "Backlog", value: "BACKLOG" },
    { label: "No Apetite", value: "NO_APETITE" },
    { label: "Selected for hackathon", value: "SELECTED_FOR_HACKATHON" },
    { label: "Idea Closed", value: "IDEA_CLOSED" }
];

 export const challengeStatus = [
    { value: "ACTIVE", label: "ACTIVE" },
    { value: "FINISHED", label: "FINISHED" }
  ];